/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_Members_Manage_Extra_Seats_UpdateInputs */

const en_space_members_manage_extra_seats_update = /** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const de_space_members_manage_extra_seats_update = /** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const es_space_members_manage_extra_seats_update = /** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const fr_space_members_manage_extra_seats_update = /** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

/** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */
const it_space_members_manage_extra_seats_update = en_space_members_manage_extra_seats_update;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */
const pt_br2_space_members_manage_extra_seats_update = en_space_members_manage_extra_seats_update;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */
const pl_space_members_manage_extra_seats_update = en_space_members_manage_extra_seats_update;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */
const hu_space_members_manage_extra_seats_update = en_space_members_manage_extra_seats_update;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_UpdateInputs) => LocalizedString} */
const ro_space_members_manage_extra_seats_update = en_space_members_manage_extra_seats_update;

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Space_Members_Manage_Extra_Seats_UpdateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const space_members_manage_extra_seats_update = /** @type {((inputs?: Space_Members_Manage_Extra_Seats_UpdateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Members_Manage_Extra_Seats_UpdateInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_space_members_manage_extra_seats_update(inputs)
	if (locale === "de") return de_space_members_manage_extra_seats_update(inputs)
	if (locale === "es") return es_space_members_manage_extra_seats_update(inputs)
	if (locale === "fr") return fr_space_members_manage_extra_seats_update(inputs)
	if (locale === "it") return it_space_members_manage_extra_seats_update(inputs)
	if (locale === "pt-BR") return pt_br2_space_members_manage_extra_seats_update(inputs)
	if (locale === "pl") return pl_space_members_manage_extra_seats_update(inputs)
	if (locale === "hu") return hu_space_members_manage_extra_seats_update(inputs)
	return ro_space_members_manage_extra_seats_update(inputs)
});
export { space_members_manage_extra_seats_update as "space.members.manage_extra_seats.update" }